module.exports = __webpack_public_path__ + "static/media/simple_es.ac31abb1.svg";